import React from 'react';
import { ArrowRight } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/8Aw9jLDp6JjxgjUoVSorDX/98930e38-5ebb-403e-a4c3-f1e5763261a4.png';
export function FooterCTA() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-74">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-75">
        <div className="mb-10 md:mb-16" data-id="element-76">
          <p className="text-xs md:text-sm font-bold tracking-widest text-red-500 uppercase mb-4 md:mb-6" data-id="element-77">
            IMPORTANTE
          </p>
          <p className="font-display text-3xl md:text-5xl font-bold text-slate-900 mb-3 md:mb-4 leading-tight" data-id="element-78">
            No necesitás más contenido.
          </p>
          <p className="text-lg md:text-2xl text-slate-600 mb-4 md:mb-6" data-id="element-79">
            Necesitás un sistema claro para dar clases sin improvisar.
          </p>
          <p className="text-base md:text-lg text-slate-800 font-medium bg-emerald-50 border border-emerald-200 py-3 px-5 md:py-4 md:px-6 rounded-xl inline-block" data-id="element-80">
            Eso es exactamente lo que vas a tener acá.
          </p>
        </div>

        <div className="bg-gradient-to-br from-slate-900 to-emerald-950 rounded-2xl md:rounded-3xl p-6 md:p-12 text-white shadow-2xl relative overflow-hidden" data-id="element-81">
          {/* Tricolor top */}
          <div className="absolute top-0 left-0 w-full h-1.5 flex" data-id="element-82">
            <div className="flex-1 bg-[#008C45]" data-id="element-83" />
            <div className="flex-1 bg-white" data-id="element-84" />
            <div className="flex-1 bg-[#CD212A]" data-id="element-85" />
          </div>

          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1523730205978-59fd1b2965e3?q=80&w=1000&auto=format&fit=crop')] bg-cover bg-center opacity-10" data-id="element-86"></div>

          <div className="relative z-10 grid md:grid-cols-2 gap-6 md:gap-10 items-center" data-id="element-87">
            <div className="text-center md:text-left" data-id="element-88">
              <h2 className="font-display text-3xl md:text-5xl font-extrabold mb-3 md:mb-5" data-id="element-89">
                ACCEDER AHORA
              </h2>
              <p className="text-base md:text-xl text-slate-300 mb-6 md:mb-8" data-id="element-90">
                Empezá hoy mismo.
                <br data-id="element-91" />
                Es tu momento de enseñar como un profesional.
              </p>
              <a href="#compra" className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white text-base md:text-lg font-bold py-4 px-7 rounded-xl shadow-xl shadow-emerald-500/30 transition-all hover:scale-105" data-id="element-92">
                QUIERO MI SISTEMA
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-93" />
              </a>
            </div>
            <div className="hidden md:block" data-id="element-94">
              <a href="#compra" data-id="element-95">
                <img src={PRODUCT_IMG} alt="Italiano Pro Kit" className="w-full max-w-xs mx-auto drop-shadow-2xl hover:scale-105 transition-transform" data-id="element-96" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}